/**
 * 公共api接口请求集合
 * @author libaoxu@gaosiedu.com 2017-01-05
 */

import SRC_CONFIG from "src/config";
import $common from "utils/common";

const getCurryUrl = $common.getCurryUrl;

/**
 * 请求类型
 * @type {Object}
 */
const REQ_TYPE = {
  POST: "post",
  GET: "get",
  JSONP: "jsonp",
  DELETE: "delete",
  HEAD: "head",
  PUT: "put",
  PATCH: "patch"
};

/**
 * 是否开发环境
 * @type {Boolean}
 */
const IS_DEV = process && process.env.NODE_ENV === "development";

/**
 * host 相关配置
 */
const CONFIG = IS_DEV ? SRC_CONFIG.DEV : SRC_CONFIG.PROD;

/**
 * 请求根链接, 线上可能是http://api.aixuexi.com/这个地址
 * @type {String}
 * @example http://192.168.199.140:8080/godfather/
 */
const ROOT_URL = CONFIG.root;


/**
 * 登录接口
 */
const LOGIN_ROOT_URL = CONFIG.login;

/**
 * root地址  post 请求函数, 执行后得到json对象
 * @type {Function}
 */
const postRoot = getCurryUrl(ROOT_URL, REQ_TYPE.POST);
const getRoot = getCurryUrl(ROOT_URL, REQ_TYPE.GET);
const putRoot = getCurryUrl(ROOT_URL, REQ_TYPE.PUT);

// TODO: MOCK
const postMock = getCurryUrl('/mock/51/thewolverine/', REQ_TYPE.POST);
const putMock = getCurryUrl('/mock/51/thewolverine/', REQ_TYPE.PUT);
const getMock = getCurryUrl('/mock/51/thewolverine/', REQ_TYPE.GET);

/**
 * 给postRoot 增加默认的参数, 变成x-www-form-urlencoded形势
 */
const postRootXForm = function(url, loading) {
  return postRoot(url, loading, {
    //以application/x-www-form-urlencoded作为MIME type，就像普通的HTML表单一样。
    emulateJSON: true
  });
};

/**
 * 登录接口post请求
 */
const postLoginRoot = getCurryUrl(LOGIN_ROOT_URL, REQ_TYPE.POST);

/**
 * 是否自动等待
 */
const AUTO_LOADING = true;

/*************** 我的直播课页面 *********************/

/**
 * 我的直播课（主讲机构）列表
 * classStatus *	班级状态	number	（0 已经结课 1 已经开课 2 即将开课 3全部）
 * classType *	班级类型	number	0普通, 1小班, 2大班' 大班：双师讲课机构 小班：双师听课机构
 * classTypeId	班型id	number	没有就填 - 1
 * gradeId	年级id	number	没有就填 - 1
 * institutionId *	机构id	number	测试填 25
 * pageIndex*	第几页	number
 * pageSize*	每页显示条数	number
 * periodId	学期id	number	没有就填 - 1
 * search	模糊查询	string	没有为空
 * subjectId	学科id	number	没有就填 - 1
 * teacherId	教师id	number	没有就填 - 1
 */
export const mylive_allClassList = postRootXForm("class/allClassList", false);

/*********我的直播课详情**************/

/*
 * 我的直播课（听课机构)详情页
 * classId	班级id	number
 */

export const mylive_detail = getRoot("class/classDetails", AUTO_LOADING);

/*********课程详情**************/

/*
 * 师训一期-课程详情
 * courseId	    课程id	 number  必填
 * userId       用户id     number  必填
 */
export const course_detail = getRoot("course/getCourseDetails", AUTO_LOADING);

/*
 * 获取作业详情
 * courseWorkId	    作业id	 number  必填
 */
export const coursework_detail = getRoot("coursework/workWatch", AUTO_LOADING);

/*********用户登录信息**************/

/*
 * 用户登录信息，判断是不是管理员
 */
export const login_info = getRoot("user/loginInfoo", AUTO_LOADING);

/*********课程报名申请记录**************/

/*
 * 师训一期-课程报名申请记录
 * courseId	    课程id	 number
 * insId 	    机构id	 number
 * userId       用户id	 number
 */
export const signUp_Records = getRoot("courseUser/signUpRecords", AUTO_LOADING);

/*********获取全部课程*************/

/*
 * 师训一期-获取全部课程
 * insId	 培训id	   number	 选填；不为空则查询机构的课程
 * page	     当前页码	 number	    选填，默认1
 * scanType	 显示类型    number	    选填 默认1(1近期 2往期)
 * userId	 用户id	   number	 选填；不为空则查询我的课程列表
 */
export const course_list = getRoot("course/getCourseList", AUTO_LOADING);

/*********获取参训学员*************/

/*
 * 师训一期-获取参训学员
 * courseId	课程ID	number	必填
 * insId	机构ID	number	必填
 * name	姓名	string	选填
 * roleId	角色ID	number	选填
 * subjectProductId	学科ID	number	选填
 */
export const user_list = postRootXForm("user/list", AUTO_LOADING);

/*********获取角色列表*************/

/*
 * 师训一期-获取角色列表
 *
 */
export const role_list = postRootXForm("role/list", AUTO_LOADING);

/*********获取学科列表*************/

/*
 * 师训一期-获取学科列表
 *
 */
export const subjectProduct_list = postRootXForm(
  "subjectProduct/list",
  AUTO_LOADING
);

/*********报名结算*************/

/*
 * 师训一期-报名结算
 * courseId	课程ID	number	必填
 * confirmPayAmount	应付金额
 * confirmPreferencePrice	优惠金额
 * userList	报名用户信息	string	1 需要审核时，必填 json数组对象 格式如下：[{"id":1,"name":"123","subjectProductNames":["1","2"],"telephone":"15566668888"},roleNames:["教师","前台"]]
 * token 扣费token
 *
 */
export const courseUser_account = postRootXForm(
  "courseUser/submit",
  AUTO_LOADING
);

/*********确认报名信息*************/

/*
 * 师训一期-确认报名信息(用于管理员)
 * courseId	课程ID	number	必填
 * serIds	用户ID数组	array<number>	必填
 *
 */
export const courseUser_signUpConfirm = postRootXForm(
  "courseUser/confirm",
  AUTO_LOADING
);

/*********申请退款*************/

/*
 * 师训一期-申请退款
 * courseId	课程ID	number	必填
 * status	状态	number	必填 状态 0 待审核 1 已报名（成功） 2 未报名 3 已取消 4 退款待审核 5 已退款 6 已退回（审核未通过）7后台补报
 * userId	用户ID	number	必填
 *
 */
export const signUpRecords_refund = getRoot("courseUser/cancel", AUTO_LOADING);

/*********更新播放/回放状态-用于统计直播和回放*************/

/*
 * 师训一期-更新播放/回放状态
 * courseId	课程ID	number
 * type	1 直播 2 回放	number
 * userId	用户ID	number
 *
 */
export const courseUser_courseUserPlay = postRootXForm(
  "courseUser/play",
  AUTO_LOADING
);

/*********申请退款*************/

/*
 * courseId	课程ID	number
 * courseUserIdId	courseUserId表的ID（请体会参数名字的含义）	number
 * status 要成为的状态 number
 * userId	用户ID	number
 */
export const apply_refund = getRoot(
  "courseUser/updateCourseUserStatus",
  AUTO_LOADING
);

/*********获取内容分类*************/

export const course_Classification = getRoot(
  "course/getContentClassification.do",
  AUTO_LOADING
);

/*********获取直播课表*************/

/*
 * courseId	课程ID	number
 */

export const course_getLiveInfoList = getRoot(
  "course/getLiveInfo",
  AUTO_LOADING
);

/*********获取课程管理教师的报告列表*************/

/*
 * courseId	课程ID	number
 * insId    机构ID number
 */

export const manage_getReportList = getRoot(
  "userEvaluation/reports",
  AUTO_LOADING
);
/*********申请购买课程-给超级管理员发送短信*************/

/*
 * courseId	课程ID	number
 */

export const course_apply = postRootXForm("course/apply", AUTO_LOADING);
/*********最新最热课程*************/
/*
 * type 1 热门 2最新
 */

export const hot_lastest = postRootXForm("course/hotLatest", AUTO_LOADING);
/*********预览查看报告*************/
/*
 * courseId	课程ID
 * userId 用户ID
 * sign 检验参数
 *
 */

export const generate_report = getRoot(
  "userEvaluation/generateOrGetReport.do",
  AUTO_LOADING
);
/*********查看报名结果*************/
/*
 * courseId	课程ID
 * userId 用户ID
 *
 */

export const get_sign_remind = getRoot(
  "course/signRemind.do",
  AUTO_LOADING
);
/*********报告轮询接口*************/
/*
 * reportRedisKey	轮询key
 *
 */

export const polling_report = getRoot(
  "userEvaluation/polling.do",
  AUTO_LOADING
);
/*********职业课列表*************/

export const course_prolist = getRoot("course/courseProList", AUTO_LOADING);
/*********职业组合课课程安排*************/
/*
 * courseId	课程id
 *
 */
export const course_stage = getRoot("course/listCourseStage.do", AUTO_LOADING);
/*********职业组合课首页轮播图*************/
/*
 * firstId	培训直播菜单ID
 * secondId 首页菜单ID
 */
export const course_stage_banners = getRoot("common/banners", AUTO_LOADING);
/*********获取AI推荐课程*************/
export const personal_course_list = getRoot("course/getPersonalCourseList", AUTO_LOADING);
/*********获取菜单*************/
/*
 * code=tr 菜单
 */
export const menu_list = getRoot("menu/menuFilter", AUTO_LOADING);

/*********获取优惠规则*************/
/*
 * courseId 课程id
 * insId 机构id
 */
export const course_detail_getCoursePreference = getRoot(
  "course/getCoursePreference.do",
  AUTO_LOADING
);
/*********大礼包列表*************/
/*
 * insId 机构id
 */
export const service_package_list = getRoot(
  "servicePackage/getList",
  AUTO_LOADING
);
/**********是否展示大礼包***************/
/*
 * insId 机构id
 */
export const is_show_packge = getRoot("servicePackage/show", AUTO_LOADING);

/*********获取专题推荐列表*************/
export const special_getList = getRoot(
  "coursePackage/special/getList",
  AUTO_LOADING
);
/*********专题详情*************/
export const special_getDetail = getRoot(
  "coursePackage/special/getDetail",
  AUTO_LOADING
);
/*********课程详情获取城市列表*************/
/*
 * courseId 课程id
 */
// export const course_detail_getCourseCityList = getRoot(
//   "coursePackage/camp/getCourseCityList.do",
//   AUTO_LOADING
// );
/*********课程详情获取学科、城市、时间列表*************/
/*
 * courseId 课程id
 */
export const course_detail_getCourseObjectList = getRoot(
  "coursePackage/camp/getObjectList.do",
  AUTO_LOADING
);

/*********课程详情获取时间或者学科列表*************/
/*
 * courseId 课程id
 * cityId 城市id（根据聚合课课程id和城市id获取时间列表）
 * startTime 课程开始时间 (根据聚合课课程id和时间段获取学科列表)
 * endTime 课程结束时间
 */
// export const course_detail_getCourseList = getRoot(
//   // "coursePackage/camp/getCourseTimeList.do",
//   "coursePackage/camp/getCourseList.do",
//   AUTO_LOADING
// );

/*********课程详情获取时间或者城市列表*************/
/*
 * courseId 课程id
 * subjectId 学科id （根据聚合课课程id和学科id获取城市列表）
 * cityId 城市id（根据聚合课课程id和城市id获取时间列表）
 * startTime 课程开始时间 (根据聚合课课程id和时间段获取学科列表)
 * endTime 课程结束时间
 */
export const course_detail_getCourseList = getRoot(
  "coursePackage/camp/getCourseList.do",
  AUTO_LOADING
);

/*********课程详情获取时间列表*************/
/*
 * type 1 校长培训 2 爱教师学院 3 学科公开课 4双师助教学院
 */
export const course_detail_getDetail = getRoot(
  "coursePackage/zone/getDetail",
  AUTO_LOADING
);
/*********获取一级导航列表及下属导航*************/
/*
 * type 1 校长培训 2 爱教师学院 3 学科公开课 4双师助教学院
 */
export const zone_nav_getNavList = getRoot(
  "coursePackage/zoneNav/getNavList.do",
  AUTO_LOADING
);

/*********获取课程属性筛选项*************/
/*
 */
export const course_detail_courseObject = getRoot(
  "course/courseObject",
  AUTO_LOADING
);

/**************获取课程地点筛选项***********/

export const course_detail_courseCity = getRoot(
  "course/courseCity",
  AUTO_LOADING
);

/**************校验CTS包的权限***********/
export const check_CTS_permissions = getRoot(
  "common/checkCTSPermissions",
  AUTO_LOADING
);

/**************培训日历课程列表***********/
export const get_trainCalendar_courseList = getRoot(
  "trainCalendar/getCourseList",
  AUTO_LOADING
);

/**************培训日历课程详情***********/
export const get_trainCalendar_CourseDetail = getRoot(
  "trainCalendar/getCourseDetail",
  AUTO_LOADING
);

/**************培训日历月份列表***********/
export const get_trainCalendar_MonthList = getRoot(
  "trainCalendar/getMonthList",
  AUTO_LOADING
);

/**************获取课程属性筛选项***********/
export const get_trainCalendar_CourseObject = getRoot(
  "common/getCourseObject",
  AUTO_LOADING
);

/**************获取上传签名***********/
export const getUploadSign = postRoot("common/storageToken", AUTO_LOADING);

/**************留言板***********/
export const message = postRoot("trainMessageBoard/message", AUTO_LOADING);

/**************留言板***********/
export const recommendCourse = getRoot("course/recommendCourse", AUTO_LOADING);

/**
 * @description: 我的报名列表
 * @param : myCourseType 我的报名列表浏览类型：1免费课 2付费课 3审核中的课 4 报名成功的课
 * @param : orderType 1 报名时间 2 开课时间
 * @param : signTime	报名时间
 * @return {type} 
 */
export const mycourse_list = getRoot("course/getMyCourseList", AUTO_LOADING);
/**
/**
 * @description: 我的报名各菜单数据量
 * @return {type} 
 */
export const mycourse_list_count = getRoot("course/getMyCourseListCount", AUTO_LOADING);
/**
 * @description: 参训列表
 * @param : sortField 培训字段 1: 报名时间 2:开课时间
 * @param : signDate 报名时间
 * @return {type} 
 */
export const attendtraining_list = getRoot("attendTraining/attendTrainingList", AUTO_LOADING);
/**
 * @description: 参训人列表
 * @param : courseId	是	课程id
 * @param : insId	是	机构Id
 * @param : userName	是	用户名称
 * @return {type} 
 */
export const attendtraining_user_list = getRoot("attendTraining/userList", AUTO_LOADING);
/**
 * @description: 参训数据-观看数据
 * @param : courseId	number 课程Id
 * @param : userIds	number []	用户id集合
 * @return {type} 
 */
export const attendtraining_view_data = postRoot("attendTraining/viewData", AUTO_LOADING);
/**
 * @description: 参训数据-作业数据
 * @param : courseId	number 课程Id
 * @param : userIds	number []	用户id集合
 * @return {type} 
 */
export const attendtraining_work_data = postRoot("attendTraining/workData", AUTO_LOADING);
/**
 * @description: 参训报告人员列表
 * @param : courseId	number 课程Id
 * @param : userIds	number []	用户id集合
 * @return {type} 
 */
export const signup_user_list = postRoot("courseUser/getSignUpUserList", AUTO_LOADING);
/**
 * @description: 报名申请列表
 * @return {type} 
 */
export const myapplication_list = getRoot("userApply/getList", AUTO_LOADING);
/**
 * @description: 报名申请管理员列表
 * @param : courseId	number 课程Id
 * @return {type} 
 */
export const manager_list = getRoot("userApply/getManagerList", AUTO_LOADING);
/**
 * @description: 管理员报名确认申请
 * @param : courseId	number 课程Id
 * @return {type} 
 */
export const application_submit = putRoot("userApply/submit", AUTO_LOADING);
/**
 * @description: 首页申请提示
 * @param : lastQueryDate	最后请求时间
 * @return {type} 
 */
export const application_remind = getRoot("userApply/remind", AUTO_LOADING);
/**
 * @description: 首页搜索-热门标签
 * @return {type} 
 */
export const getHotSearchWords = getRoot("common/hotSearchWords", AUTO_LOADING);
/**
 * @description: 首页搜索-热门标签
 * @return {type} 
 */
export const getRelateSearch = getRoot("common/relateSearchWords", AUTO_LOADING);
/**
 * @description: 课程详情-留言列表
 */
export const getMessageList = getRoot("courseMessage/getList", AUTO_LOADING);
/**
 * @description: 课程详情-留言可见隐藏
 */
export const switchMessageStatus = postRootXForm("courseMessage/status", AUTO_LOADING);
/**
 * @description: 课程详情-课程留言发布
 */
export const courseSaveMsg = putRoot("courseMessage/saveMsg", AUTO_LOADING);
/**
 * @description: 我的留言-回复我的
 */
export const getReplyMeList = getRoot("courseMessage/getReplyMeList", AUTO_LOADING);
/**
 * @description: 我的留言-回复我的个数
 */
export const getReplyMeCount = getRoot("courseMessage/getReplyMeCount", AUTO_LOADING);
/**
 * @description: 首页推荐-感兴趣列表
 */
export const getLabelList = getRoot("aiCourse/labelList", AUTO_LOADING);
/**
 * @description: 首页推荐-感兴趣回显
 */
export const getInterestLabel = getRoot("aiCourse/userInterestLabel", AUTO_LOADING);
/**
 * @description: 首页推荐-保存感兴趣标签
 */
export const saveInterestLabel = postRoot("aiCourse/saveUserInterestLabel", AUTO_LOADING);
